(() => {
      const video = document.getElementById('heroVideo');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!reduceMotion) {
        let ticking = false;
        const updateHero = () => {
          const y = Math.min(window.scrollY, window.innerHeight);
          video.style.setProperty('--hero-scroll-y', `${y * 0.035}px`);
          ticking = false;
        };
        window.addEventListener('scroll', () => {
          if (!ticking) { requestAnimationFrame(updateHero); ticking = true; }
        }, { passive: true });
      }

      const revealElements = document.querySelectorAll('.reveal');

      const birthdayRevealOverlay = document.getElementById('birthdayRevealOverlay');
      const birthdayRevealClose = document.getElementById('birthdayRevealClose');
      const birthdayMerchForm = document.getElementById('birthdayMerchForm');
      const birthdayName = document.getElementById('birthdayName');
      const birthdayEmail = document.getElementById('birthdayEmail');
      const birthdayMobile = document.getElementById('birthdayMobile');
      const birthdayNameError = document.getElementById('birthdayNameError');
      const birthdayFormError = document.getElementById('birthdayFormError');
      const birthdayFormSuccess = document.getElementById('birthdayFormSuccess');
      const birthdaySubmit = document.getElementById('birthdaySubmit');
      const birthdaySubmitIdleNodes = birthdaySubmit
        ? Array.from(birthdaySubmit.childNodes, (node) => node.cloneNode(true))
        : [];
      const gameSection = document.getElementById('divine-alignment');
      let birthdayRevealShown = false;
      let merchSuccessToastTimeout = null;

      birthdayRevealOverlay?.setAttribute('aria-labelledby', 'birthdayRevealTitleMerch');

      const resetMerchFeedback = () => {
        if (merchSuccessToastTimeout) {
          window.clearTimeout(merchSuccessToastTimeout);
          merchSuccessToastTimeout = null;
        }
        birthdayNameError.hidden = true;
        birthdayNameError.textContent = '';
        birthdayFormError.hidden = true;
        birthdayFormError.textContent = '';
        birthdayFormSuccess.hidden = true;
        birthdayFormSuccess.textContent = '';
      };

      const closeBirthdayReveal = (shouldResetFeedback = true) => {
        if (!birthdayRevealOverlay || birthdayRevealOverlay.hidden) return;
        birthdayRevealOverlay.hidden = true;
        document.body.classList.remove('birthday-popup-open');
        if (shouldResetFeedback) resetMerchFeedback();
      };

      const openBirthdayReveal = () => {
        if (!birthdayRevealOverlay || !birthdayRevealOverlay.hidden) return;
        birthdayRevealShown = true;
        birthdayRevealOverlay.hidden = false;
        document.body.classList.add('birthday-popup-open');
        resetMerchFeedback();
        setTimeout(() => (birthdayName || birthdayRevealClose)?.focus(), 80);
      };

      birthdayRevealClose?.addEventListener('click', closeBirthdayReveal);

      birthdayRevealOverlay?.addEventListener('click', (event) => {
        if (event.target === birthdayRevealOverlay) closeBirthdayReveal();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && birthdayRevealOverlay && !birthdayRevealOverlay.hidden) {
          closeBirthdayReveal();
        }
      });

      if (gameSection) {
        if ('IntersectionObserver' in window) {
          const birthdayObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !birthdayRevealShown) {
                openBirthdayReveal();
                birthdayObserver.unobserve(entry.target);
              }
            });
          }, {
            threshold:0.18,
            rootMargin:'0px 0px -12% 0px'
          });

          birthdayObserver.observe(gameSection);
        } else {
          openBirthdayReveal();
        }
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.16 });

        revealElements.forEach((el) => observer.observe(el));
      } else {
        revealElements.forEach((el) => el.classList.add('in-view'));
      }

      video.play().catch(() => {
        const resume = () => {
          video.play().catch(() => {});
          window.removeEventListener('pointerdown', resume);
        };
        window.addEventListener('pointerdown', resume, { once: true });
      });

      const entryOverlay = document.getElementById('entryOverlay');
      const openEntryForm = document.getElementById('openEntryForm');
      const closeEntry = document.getElementById('closeEntry');
      const warningOverlay = document.getElementById('warningOverlay');
      const closeWarning = document.getElementById('closeWarning');
      const warningAcknowledge = document.getElementById('warningAcknowledge');
      const detailsForm = document.getElementById('detailsForm');
      const playerName = document.getElementById('playerName');
      const playerEmail = document.getElementById('playerEmail');
      const playerMobile = document.getElementById('playerMobile');
      const nameError = document.getElementById('nameError');
      const detailsError = document.getElementById('detailsError');
      const submitButton = detailsForm?.querySelector('button[type="submit"]');
      const submitIdleNodes = submitButton
        ? Array.from(submitButton.childNodes, (node) => node.cloneNode(true))
        : [];

      const PREORDER_URL = 'https://varanasimovie.com/apps/preorder';
      let pendingRegistration = null;

      const alreadySpunOverlay = document.getElementById('alreadySpunOverlay');
      const alreadySpunText = document.getElementById('alreadySpunText');
      const alreadySpunPerk = document.getElementById('alreadySpunPerk');
      const backHomeButton = document.getElementById('backHomeButton');

      const showAlreadySpunPopup = (status = {}) => {
        const isWinner = status?.isWinner === true;
        const apiMessage = String(status?.error || status?.message || '').trim();

        alreadySpunText.textContent = apiMessage || (
          isWinner
            ? 'Your previous spin is already recorded, and it was a winning spin.'
            : 'You have already completed your spin for this mobile number.'
        );

        if (isWinner && status?.perkCode) {
          alreadySpunPerk.textContent = 'PERK CODE · ' + status.perkCode;
          alreadySpunPerk.hidden = false;
        } else {
          alreadySpunPerk.hidden = true;
          alreadySpunPerk.textContent = '';
        }

        detailsError.hidden = true;
        detailsError.textContent = '';

        entryOverlay.hidden = true;
        document.body.classList.remove('entry-modal-open');
        alreadySpunOverlay.hidden = false;
      };

      const isAlreadySpunApiError = (error) => {
        const message = String(error?.message || error || '').toLowerCase();
        return (
          message.includes('already completed your spin') ||
          message.includes('already completed the spin') ||
          message.includes('already spun') ||
          (message.includes('spin') && message.includes('already'))
        );
      };

      backHomeButton?.addEventListener('click', () => {
        window.location.href = '/';
      });
      const openWarningPopup = () => {
        if (!warningOverlay || !warningOverlay.hidden) return;
        warningOverlay.hidden = false;
        document.body.classList.add('entry-modal-open');
        setTimeout(() => (warningAcknowledge || closeWarning)?.focus(), 50);
      };

      const closeWarningPopup = () => {
        if (!warningOverlay || warningOverlay.hidden) return;
        warningOverlay.hidden = true;
        document.body.classList.remove('entry-modal-open');
      };

      const openRegistration = () => {
        entryOverlay.hidden = false;
        document.body.classList.add('entry-modal-open');
        pendingRegistration = null;
        detailsError.hidden = true;
        detailsError.textContent = '';
        detailsForm.hidden = false;
        setTimeout(() => playerName.focus(), 50);
      };

      const closeRegistration = () => {
        entryOverlay.hidden = true;
        document.body.classList.remove('entry-modal-open');
        detailsError.hidden = true;
        detailsError.textContent = '';
        pendingRegistration = null;
        detailsForm.hidden = false;
      };

playerName.addEventListener('input', () => {
  nameError.hidden = true;
  nameError.textContent = '';
});

      birthdayName?.addEventListener('input', () => {
        resetMerchFeedback();
      });

      birthdayEmail?.addEventListener('input', () => {
        resetMerchFeedback();
      });

      birthdayMobile?.addEventListener('input', () => {
        let value = birthdayMobile.value;
        value = value.replace(/[^\d+\s().-]/g, '');

        if (value.includes('+')) {
          value = (value.startsWith('+') ? '+' : '') + value.replace(/\+/g, '');
        }

        birthdayMobile.value = value.slice(0, 24);
        resetMerchFeedback();
      });

      openEntryForm.addEventListener('click', openWarningPopup);
      closeEntry.addEventListener('click', closeRegistration);
      closeWarning?.addEventListener('click', closeWarningPopup);
      warningAcknowledge?.addEventListener('click', closeWarningPopup);

      warningOverlay?.addEventListener('click', (event) => {
        if (event.target === warningOverlay) closeWarningPopup();
      });

      entryOverlay.addEventListener('click', (event) => {
        if (event.target === entryOverlay) closeRegistration();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && warningOverlay && !warningOverlay.hidden) closeWarningPopup();
        if (event.key === 'Escape' && !entryOverlay.hidden) closeRegistration();
      });

      playerMobile.addEventListener('input', () => {
        let value = playerMobile.value;

        value = value.replace(/[^\d+\s().-]/g, '');

        if (value.includes('+')) {
          value = (value.startsWith('+') ? '+' : '') + value.replace(/\+/g, '');
        }

        playerMobile.value = value.slice(0, 24);
      });

      const normalizePhone = (rawValue) => {
        let raw = String(rawValue || '').trim();

        if (raw.startsWith('00')) raw = '+' + raw.slice(2);

        const hasPlus = raw.startsWith('+');
        const digits = raw.replace(/\D/g, '');

        if (!digits) {
          return { ok:false, error:'Please enter your mobile number.' };
        }

        if (/^(\d)\1+$/.test(digits) || /^(\d{2,4})\1{2,}$/.test(digits)) {
          return { ok:false, error:'Please enter a valid mobile number.' };
        }

        if (!hasPlus && /^[6-9]\d{9}$/.test(digits)) {
          const e164 = '+91' + digits;
          return { ok:true, e164, apiMobile:e164 };
        }

        if (hasPlus && digits.length >= 8 && digits.length <= 15 && !digits.startsWith('0')) {
          const e164 = '+' + digits;

          if (e164.startsWith('+91')) {
            const indiaLocal = e164.slice(3);
            if (!/^[6-9]\d{9}$/.test(indiaLocal)) {
              return { ok:false, error:'Please enter a valid Indian mobile number.' };
            }
          }

          return { ok:true, e164, apiMobile:e164 };
        }

        return {
          ok:false,
          error:'Use a valid number, for example 9800453705 or +447911123456.'
        };
      };

      birthdayMerchForm?.addEventListener('submit', async (event) => {
        event.preventDefault();

        const name = birthdayName.value.trim();
        const email = birthdayEmail.value.trim();
        const phone = normalizePhone(birthdayMobile.value);

        const validName =
          name.length >= 2 &&
          name.length <= 80 &&
          /^[\p{L}\p{M}][\p{L}\p{M}\s.'â€™\-]*$/u.test(name);

        if (!validName) {
          birthdayNameError.textContent = 'Please enter a valid name using letters only.';
          birthdayNameError.hidden = false;
          birthdayFormError.hidden = true;
          birthdayFormError.textContent = '';
          birthdayName.focus();
          return;
        }

        birthdayNameError.hidden = true;
        birthdayNameError.textContent = '';

        if (!/^\S+@\S+\.\S+$/.test(email)) {
          birthdayFormError.textContent = 'Please enter a valid email address.';
          birthdayFormError.hidden = false;
          return;
        }

        if (!phone.ok) {
          birthdayFormError.textContent = phone.error;
          birthdayFormError.hidden = false;
          return;
        }

        birthdayFormError.hidden = true;
        birthdayFormError.textContent = '';
        birthdayFormSuccess.hidden = true;
        birthdayFormSuccess.textContent = '';

        if (birthdaySubmit) {
          birthdaySubmit.disabled = true;
          birthdaySubmit.setAttribute('aria-busy', 'true');
          birthdaySubmit.textContent = 'JOINING...';
        }

        try {
          const response = await fetch(PREORDER_URL, {
            method:'POST',
            headers:{
              'Accept':'application/json',
              'Content-Type':'application/x-www-form-urlencoded'
            },
            body:new URLSearchParams({
              name,
              email,
              mobile:phone.apiMobile
            }).toString()
          });

          const result = await response.json().catch(() => null);

          if (!response.ok || !result?.ok) {
            throw new Error(result?.error || result?.message || 'Unable to save your details right now.');
          }

          birthdayMerchForm.reset();
          birthdayFormSuccess.textContent = 'Thanks. You are on the list for Official Varanasi merchandise updates.';
          birthdayFormSuccess.hidden = false;
          closeBirthdayReveal(false);
          merchSuccessToastTimeout = window.setTimeout(() => {
            birthdayFormSuccess.hidden = true;
            birthdayFormSuccess.textContent = '';
            merchSuccessToastTimeout = null;
          }, 5000);
        } catch (error) {
          birthdayFormError.textContent = error instanceof Error
            ? error.message
            : 'Unable to save your details right now.';
          birthdayFormError.hidden = false;
        } finally {
          if (birthdaySubmit) {
            birthdaySubmit.disabled = false;
            birthdaySubmit.removeAttribute('aria-busy');
            birthdaySubmit.replaceChildren(
              ...birthdaySubmitIdleNodes.map((node) => node.cloneNode(true))
            );
          }
        }
      });

      const continueRegistration = async () => {
        const { name, email, phone } = pendingRegistration;

        const statusUrl =
          GAME_STATUS_URL + '?mobile=' + encodeURIComponent(phone.apiMobile);

        const statusResponse = await fetch(statusUrl, {
          method:'GET',
          headers:{ 'Accept':'application/json' },
          mode:'cors',
          cache:'no-store',
          credentials:'omit'
        });

        const status = await statusResponse.json().catch(() => null);

        if (!statusResponse.ok || !status?.ok) {
          throw new Error(status?.error || 'Unable to verify your game status right now.');
        }

        const alreadyPlayed =
          status.hasPlayed === true ||
          status.hasSpun === true;

        if (alreadyPlayed) {
          showAlreadySpunPopup(status);
          return;
        }

        const response = await fetch(PREORDER_URL, {
          method:'POST',
          headers:{
            'Accept':'application/json',
            'Content-Type':'application/x-www-form-urlencoded'
          },
          body:new URLSearchParams({
            name,
            email,
            mobile:phone.apiMobile
          }).toString()
        });


        const result = await response.json().catch(() => null);

        if (!response.ok || !result?.ok) {
          throw new Error(result?.error || result?.message || 'Unable to save your details right now.');
        }

        sessionStorage.setItem('varanasiPlayer', JSON.stringify({
          name,
          email,
          mobile:phone.apiMobile,
          mobileE164:phone.apiMobile,
          enteredAt:Date.now(),
          submissionId:result.submissionId || null,
          shop:result.shop || null,
          preorderStatus:result.status || null
        }));

        sessionStorage.setItem('varanasiGameAccess', '1');

        window.location.href = '/pages/game';
      };
      detailsForm.addEventListener('submit', async (event) => {
        event.preventDefault();

        const name = playerName.value.trim();
        const email = playerEmail.value.trim();
        const phone = normalizePhone(playerMobile.value);

        const validName =
  name.length >= 2 &&
  name.length <= 80 &&
  /^[\p{L}\p{M}][\p{L}\p{M}\s.'’\-]*$/u.test(name);

if (!validName) {
  nameError.textContent = 'Please enter a valid name using letters only.';
  nameError.hidden = false;

  detailsError.hidden = true;
  detailsError.textContent = '';

  playerName.focus();
  return;
}

nameError.hidden = true;
nameError.textContent = '';

        if (!/^\S+@\S+\.\S+$/.test(email)) {
          detailsError.textContent = 'Please enter a valid email address.';
          detailsError.hidden = false;
          return;
        }

        if (!phone.ok) {
          detailsError.textContent = phone.error;
          detailsError.hidden = false;
          return;
        }

        detailsError.hidden = true;
        detailsError.textContent = '';
        pendingRegistration = { name, email, phone };

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy','true');
          submitButton.textContent = 'ENTERING...';
        }

        try {
          await continueRegistration();
        } catch (error) {
          if (isAlreadySpunApiError(error)) {
            showAlreadySpunPopup({
              error:error instanceof Error
                ? error.message
                : 'You have already completed your spin for this mobile number.'
            });
          } else {
            detailsError.textContent = error instanceof Error
              ? error.message
              : 'Unable to continue right now.';
            detailsError.hidden = false;
          }
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.replaceChildren(
              ...submitIdleNodes.map((node) => node.cloneNode(true))
            );
          }
        }
      });

      const trishulCursor = document.getElementById('trishulCustomCursor');
      if (trishulCursor && window.matchMedia('(pointer:fine)').matches) {
        let cursorX = -100;
        let cursorY = -100;
        let cursorRAF = 0;

        const renderTrishulCursor = () => {
          trishulCursor.style.left = cursorX + 'px';
          trishulCursor.style.top = cursorY + 'px';
          cursorRAF = 0;
        };

        window.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') return;
          cursorX = event.clientX;
          cursorY = event.clientY;
          trishulCursor.classList.add('is-visible');

          if (event.target.closest('button, a, input, select, textarea, [role="button"]')) {
            trishulCursor.classList.add('is-hover');
          } else {
            trishulCursor.classList.remove('is-hover');
          }

          if (!cursorRAF) {
            cursorRAF = requestAnimationFrame(renderTrishulCursor);
          }
        }, { passive:true });

        document.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') trishulCursor.classList.add('is-active');
        }, { passive:true });

        document.addEventListener('pointerup', () => {
          trishulCursor.classList.remove('is-active');
        }, { passive:true });

        document.addEventListener('mouseleave', () => {
          trishulCursor.classList.remove('is-visible');
        });

        window.addEventListener('blur', () => {
          trishulCursor.classList.remove('is-visible');
        });
      }

    })();
